import aria from "../../assets/partners/aria.png";
import avanseo from "../../assets/partners/avanseo.png";
import capec from "../../assets/partners/capec.jpg";
import corhofi from "../../assets/partners/corhofi.png";
import defacto from "../../assets/partners/defacto.png";
import dimpl from "../../assets/partners/dimpl.png";
import edebex from "../../assets/partners/edebex.png";
import gcollect from "../../assets/partners/gcollect.png";
import karmen from "../../assets/partners/karmen.png";
import memobank from "../../assets/partners/memobank.png";
import ocean from "../../assets/partners/ocean.png";
import october from "../../assets/partners/october.png";
import riverbank from "../../assets/partners/riverbank.png";
import silvr from "../../assets/partners/silvr.png";
import unlimitd from "../../assets/partners/unlimitd.png";
import youtrade from "../../assets/partners/youtrade.png";

export default function usePartners() {
  return [
    {
      id: "Aria",
      name: "Aria",
      logo: aria,
    },
    {
      id: "Avanseo",
      name: "Avanseo",
      logo: avanseo,
    },
    {
      id: "CapEc",
      name: "CapEc",
      logo: capec,
    },
    {
      id: "Corhofi",
      name: "Corhofi",
      logo: corhofi,
    },
    {
      id: "Defacto",
      name: "Defacto",
      logo: defacto,
    },
    {
      id: "Dimpl",
      name: "Dimpl",
      logo: dimpl,
    },
    {
      id: "Edebex",
      name: "Edebex",
      logo: edebex,
    },
    {
      id: "GCollect",
      name: "GCollect",
      logo: gcollect,
    },
    {
      id: "Karmen",
      name: "Karmen",
      logo: karmen,
    },
    {
      id: "KarmenFactor",
      name: "Karmen Factor",
      logo: karmen,
      duplicate: true,
    },
    {
      id: "MemoBank",
      name: "MemoBank",
      logo: memobank,
    },
    {
      id: "Ocean",
      name: "Ocean",
      logo: ocean,
    },
    {
      id: "October",
      name: "October",
      logo: october,
    },
    {
      id: "RiverBank",
      name: "RiverBank",
      logo: riverbank,
    },
    {
      id: "RiverBankInstant",
      name: "RiverBank Instant",
      logo: riverbank,
      duplicate: true,
    },
    {
      id: "Silvr",
      name: "Silvr",
      logo: silvr,
    },
    {
      id: "Unlimitd",
      name: "Unlimitd",
      logo: unlimitd,
    },
    {
      id: "YouTrade",
      name: "YouTrade",
      logo: youtrade,
    },
  ];
}
